import React from 'react';

import { useState } from "react";
import YearlySalaryTable from "./YearlySalaryTable";

import "../../assets/css/salary.css";
import SalaryWidget from "../dashboard/interim/salary";
import AttestationsWidget from "./attestations";

export default function SalaryBoard() {
    const [data, setData] = useState([
        {
            id: 1,
            year: 2025,
            month: 2,
            file: 'toto',
            company: 'Hotel de Ville',
        }, {
            id: 2,
            year: 2025,
            month: 3,
            file: 'toto',
            company: 'Hotel de Ville',
        }, {
            id: 3,
            year: 2024,
            month: 1,
            file: 'toto',
            company: 'Hotel de Ville',
        }, {
            id: 4,
            year: 2024,
            month: 2,
            file: 'toto',
            company: 'Hotel de Ville',
        }, {
            id: 5,
            year: 2024,
            month: 3,
            file: 'toto',
            company: 'Hotel de Ville',
        }, {
            id: 6,
            year: 2023,
            month: 1,
            file: 'toto',
            company: 'Hotel de Ville',
        }
    ]);

    const [years, setYears] = useState([]);

    for (const d of data) {
        if (!years.includes(d.year)) {
            years.push(d.year);
        }
    }

    const [selected, setSelected] = useState("Date croissante");
    const [open, setOpen] = useState(false);

    const handleSelect = (value) => {
        setSelected(value);
        setOpen(false);
        // ici tu pourrais trier ton tableau offer selon la valeur choisie
    };
    const options = ["Date croissante", "Date décroissante"];


    return (
        <section className="salary-board">
            <div className="container">

                <div className="filters">
                    <h3>Paie</h3>
                    <p>Trier par</p>
                    <div className="custom-dropdown" onClick={() => setOpen(!open)}>
                        <button className="custom-dropdown-button">
                            {selected}
                            <i
                                className={`fa-solid fa-chevron-down ${open ? "rotate" : ""}`}
                            ></i>
                        </button>

                        {open && (
                            <ul className="custom-dropdown-menu">
                                {options.map((option) => (
                                    <li
                                        key={option}
                                        onClick={() => handleSelect(option)}
                                        className={`custom-dropdown-item ${
                                            selected === option ? "active" : ""
                                        }`}
                                    >
                                        {option}
                                        {selected === option && (
                                            <i className="fa-solid fa-check check-icon"></i>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <input type={"text"} id={"search"} placeholder={"Rechercher..."} />
                </div>

                { years.map((year) => (
                    <YearlySalaryTable key={year} data={data} year={year} />
                ))}

            </div>
            <div className="container">
                <SalaryWidget />
                <AttestationsWidget />
            </div>
        </section>
    )
}